import axios from "axios";
import router from "@/router";

const per_page = 12
const getCourses = async (context) => {
    await context.commit('setCourses', null)
    const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/courses/v1/course-list/${document.location.search ? document.location.search + '&' : '?'}per_page=${per_page}&page=1`, {
        headers: {
            'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
        }
    })).data
    if (response.success) {
        await context.commit('setCourses', response)
    } else {
        await context.commit('setError', response.code)
    }
};
const getCoursesHome = async (context) => {
    const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/courses/v1/course-list/${document.location.search ? document.location.search + '&' : '?'}per_page=${per_page}&page=1`, {
        headers: {
            'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
        }
    })).data
    if (response.success) {
        await context.commit('setCoursesHome', response)
    } else {
        await context.commit('setError', response.code)
    }
};

const getCourse = async (context, id) => {
    await context.commit('setCourse', null)
    const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/courses/v1/course-detail/${id}/`, {
        headers: {
            'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
        }
    })).data
    if (response.success) {
        await context.commit('setCourse', response.result)
    } else {
        await context.commit('setError', response.code)
    }
};
const getCoursesById = async (context, id) => {
    await context.commit('setCourses', null)
    const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/courses/v1/course-list/?per_page=${per_page}&cat_id=${id}`, {
        headers: {
            'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
        }
    })).data
    if (response.success) {
        await context.commit('setCourses', response)
    } else {
        await context.commit('setCourses', [])
        await context.commit('setError', response.code)
    }
};
const paginationCourses = async (context, obj) => {
    const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/courses/v1/course-list/${document.location.search ? document.location.search + '&' : '?'}per_page=${per_page}&page=${obj}`, {
        headers: {
            'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
        }
    })).data
    if (response.success) {
        await context.commit('pushCourse', response)
    } else {
        await context.commit('setError', response.code)
    }
};


const getReviewsById = async (context, obj) => {
    await context.commit('setReviews', null)
    const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/reviews/v1/review-list/${obj.id}/?per_page=5`, {
        headers: {
            'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
        }
    })).data
    if (response.success) {
        await context.commit('setReviews', response)
    } else {
        await context.commit('setError', response.code)
    }
};
const paginationReviews = async (context, obj) => {
    await context.commit('pushReviews', null)
    const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/reviews/v1/review-list/${obj.id}?per_page=5&page=${obj.page}`, {
        headers: {
            'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
        }
    })).data
    if (response.success) {
        await context.commit('pushReviews', response)
    } else {
        await context.commit('setError', response.code)
    }
};

const postReviews = async (context, obj) => {
    await context.commit('postReviews', null)
    const response = (await axios.post(`${process.env.VUE_APP_API_URL}/api/reviews/v1/review-create/`, obj, {
        headers: {
            'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
        }
    })).data
    if (!response.success) {
        await context.commit('setError', response.code)
    }
};
const getLessonById = async (context, obj) => {
    await context.commit('setLesson', null)
    const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/courses/v1/lesson-detail/${obj}/`, {
        headers: {
            'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
        }
    })).data
    if (response.success) {
        await context.commit('setLesson', response.result)
    } else {
        await context.commit('setLesson', response.code)
    }
};
const certificatedCourses = async (context, obj) => {
    await context.commit('setCertificatedCourses', null)
    const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/courses/v1/certificated-courses/?per_page=${per_page}&page=${obj.page}`, {
        headers: {
            'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
        }
    })).data
    if (response.success) {
        await context.commit('setCertificatedCourses', response)
    } else {
        await context.commit('setError', response.code)
    }
};
const paginationCertificatedCourses = async (context, obj) => {
    const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/courses/v1/certificated-courses/?per_page=${per_page}&page=${obj}`, {
        headers: {
            'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
        }
    })).data
    if (response.success) {
        await context.commit('pushCertificatedCourses', response)
    } else {
        await context.commit('setError', response.code)
    }
};
const completeCourse = async (context, status) => {
    await context.commit('setNotification', null)
    const response = (await axios.patch(`${process.env.VUE_APP_API_URL}/api/courses/v1/user-lessons/update/${status.id}/`, {status: status.status}, {
        headers: {
            'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
        }
    })).data
    if (response.success) {
        await context.commit('setNotification', response.code)
    } else {
        await context.commit('setError', response.code)
    }
};
const getQuizBySlug = async (context, obj) => {
    await context.commit('setQuizInfo', null)

    try {
        const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/quizzes/v1/quizzes/${obj}/?lang=${context.getters.attestationLang}`, {
            headers: {
                'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
            }
        })).data
        if (response.status) {
            await context.commit('setQuizInfo', response)
        } else {
            await context.commit('setError', response.code)
        }
    } catch (e) {
        if (e.response.status === 403) {
            router.back()
        }
    }

};
const getQuizByIdHeader = async (context, obj) => {
    await context.commit('setQuizHeader', null)
    const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/quizzes/v1/quizzes/my/${obj.slug}/data/?lang=${context.getters.attestationLang}`, {
        headers: {
            'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
        }
    })).data
    if (response.success) {
        await context.commit('setQuizHeader', response)
    } else {
        await context.commit('setError', response.code)
    }
};
const getQuizById = async (context, obj) => {
    await context.commit('setQuiz', null)
    const response = (await axios.get(`${process.env.VUE_APP_API_URL}/api/quizzes/v1/quizzes/my/${obj.slug}/questions/?per_page=1&page=${obj.page}&lang=${context.getters.attestationLang}`, {
        headers: {
            'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
        }
    })).data
    if (response.success) {
        await context.commit('setQuiz', response)
    } else {
        await context.commit('setError', response.code)
    }
};
const getQuizSaveAnswer = async (context, obj) => {
    await context.commit('setNotification', null)
    try {
        const response = (await axios.patch(`${process.env.VUE_APP_API_URL}/api/quizzes/v1/save-answer/?question=${obj.question}&answers=${obj.answer}`, {}, {
            headers: {
                'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
            }
        })).data
        if (response.success) {
            await context.commit('setNotification', response.code)
        } else {
            await context.commit('setError', response.code)
        }
    } catch (e) {
        if (e.response && e.response.status === 403) {
            await context.commit('setError', 'quiz-blocked')
        } else {
            throw e.response
        }
    }

};
const submitQuiz = async (context, obj) => {
    await context.commit('setSubmitQuiz', null)
    try {
        const response = (await axios.post(`${process.env.VUE_APP_API_URL}/api/quizzes/v1/quizzes/${obj}/submit/`, {}, {
            headers: {
                'Authorization': localStorage.getItem('access') ? `Bearer ${localStorage.getItem('access')}` : ''
            }
        })).data
        if (response.success) {
            await context.commit('setSubmitQuiz', response)
            if (response.code === 902) {
                // A large number of incorrect answers. Decrease chance
                await context.commit('setError', 902)
            } else if (response.code === 903) {
                // User blocked
                await context.commit('setError', 903)
            } else {
                await context.commit('setNotification', 904)
                await router.push(`/certified/${response.quiz.certificated_course}`)
            }
        } else {
            await context.commit('setError', response.code)
        }
    } catch (e) {
        if (e.response && e.response.status === 403) {
            await context.commit('setError', 'quiz-blocked')
        } else {
            throw e.response
        }
    }

};

export default {
    getCourses,
    getCoursesHome,
    getCoursesById,
    getCourse,
    getReviewsById,
    paginationReviews,
    paginationCourses,
    paginationCertificatedCourses,
    getLessonById,
    getQuizById,
    getQuizByIdHeader,
    certificatedCourses,
    completeCourse,
    getQuizBySlug,
    getQuizSaveAnswer,
    submitQuiz,
    postReviews
}